// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import './BannerActionButtons.scss';

type Props = {
  id: string,
  onAskRemove: () => void,
};

const BannerActionButtons = ({ id, onAskRemove }: Props) => (
  <div className="BannerActionButtons">
    <Link to={`/write?edit_id=${id}&type=banner`} className="btn">
      수정
    </Link>
    <button className="btn" onClick={onAskRemove}>
      삭제
    </button>
  </div>
);

export default BannerActionButtons;



// WEBPACK FOOTER //
// ./src/components/banner/BannerActionButtons/BannerActionButtons.js